import React, { PropTypes } from 'react';

const FlexContainer = ((props) => {
  const { children, className } = props;
  return (
    <div id='flex' className={ ` ${ className } ` }>
      { children }
    </div>
  );
});

FlexContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default FlexContainer;
